export enum ETipoDeclaracao {
  TITULAR_ARRENDATARIO = 'Titular ou Arrendatário',
  PRIMEIRO_ADQUIRENTE = 'Primeiro Adquirente',
  HASTA_PUBLICA = 'Arrematante em Hasta Pública',
}

interface TipoDeclaracaoInfo {
  nome: string;
  indice: number;
  label: string;
}

export const TipoDeclaracaoDetalhe: { [key in ETipoDeclaracao]: TipoDeclaracaoInfo } = {
  [ETipoDeclaracao.TITULAR_ARRENDATARIO]: {
    nome: 'TITULAR_ARRENDATARIO',
    indice: 0,
    label: 'Titular ou Arrendatário',
  },
  [ETipoDeclaracao.PRIMEIRO_ADQUIRENTE]: {
    nome: 'PRIMEIRO_ADQUIRENTE',
    indice: 1,
    label: 'Primeiro Adquirente',
  },
  [ETipoDeclaracao.HASTA_PUBLICA]: {
    nome: 'HASTA_PUBLICA',
    indice: 2,
    label: 'Arrematante em Hasta Pública',
  },
};

export function getValueFromETipoDeclaracaoByIndex(index: number) {
  const labels = Object.values(ETipoDeclaracao);
  return labels[index];
}
